module.exports = __webpack_public_path__ + "fonts/86ACBB57A4298CDE5.eot";